import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { CTAButton } from '../ui/CTAButton';
export function MechanismSection() {
  return <section className="py-16 md:py-24 bg-[#166534] text-white px-4" data-id="element-281">
      <div className="max-w-3xl mx-auto" data-id="element-282">
        <FadeInSection data-id="element-283">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-amber-50" data-id="element-284">
            El Secreto: El Escudo Metabólico y la Secuencia de Oro
          </h2>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed mb-12 text-green-50" data-id="element-285">
            <p data-id="element-286">
              El secreto no está en dejar de comer lo que te gusta. El secreto
              está en cambiar el ORDEN en que lo comes.
            </p>
            <p data-id="element-287">
              Te presento "La Secuencia de Oro", el método científicamente
              probado para crear tu propio Escudo Metabólico.
            </p>

            <div className="bg-green-800/50 rounded-2xl p-8 my-8 space-y-8 border border-green-600" data-id="element-288">
              <div className="flex items-start" data-id="element-289">
                <span className="flex-shrink-0 w-12 h-12 bg-amber-400 text-green-900 rounded-full flex items-center justify-center font-bold text-2xl mr-4" data-id="element-290">
                  1
                </span>
                <div data-id="element-291">
                  <h3 className="text-2xl font-bold text-amber-400 mb-2" data-id="element-292">
                    Fibra Primero
                  </h3>
                  <p data-id="element-293">
                    Una simple porción de vegetales o ensalada crea una malla
                    protectora en tu estómago que frena la absorción rápida del
                    azúcar.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-294">
                <span className="flex-shrink-0 w-12 h-12 bg-amber-400 text-green-900 rounded-full flex items-center justify-center font-bold text-2xl mr-4" data-id="element-295">
                  2
                </span>
                <div data-id="element-296">
                  <h3 className="text-2xl font-bold text-amber-400 mb-2" data-id="element-297">
                    Proteína y Grasa
                  </h3>
                  <p data-id="element-298">
                    Luego comes tu pollo, carne, huevos o aguacate. Esto
                    estabiliza tu digestión y te mantiene lleno por horas.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-299">
                <span className="flex-shrink-0 w-12 h-12 bg-amber-400 text-green-900 rounded-full flex items-center justify-center font-bold text-2xl mr-4" data-id="element-300">
                  3
                </span>
                <div data-id="element-301">
                  <h3 className="text-2xl font-bold text-amber-400 mb-2" data-id="element-302">
                    Carbohidratos al Final
                  </h3>
                  <p data-id="element-303">
                    Ahora sí, disfruta tu arroz, tus tortillas o tu pan. Al
                    comerlos al final, su impacto en tu glucosa es mínimo.
                  </p>
                </div>
              </div>
            </div>

            <p data-id="element-304">Sin picos masivos de azúcar, no hay caídas bruscas.</p>
            <p data-id="element-305">
              Sin caídas bruscas, no hay antojos incontrolables ni bajones de
              energía. Es así de simple y poderoso.
            </p>
          </div>

          <div className="text-center" data-id="element-306">
            <CTAButton text="Descargar Mi Copia Ahora" className="bg-amber-500 hover:bg-amber-600 text-green-900" data-id="element-307" />
          </div>
        </FadeInSection>
      </div>
    </section>;
}